export default __webpack_public_path__ + "static/media/material-icons.c34f1719.woff";